import { gql } from '@apollo/client';

export const ME = gql`
  query isAuthenticated {
    isAuthenticated
  }
`;
